import { type DocumentNode, gql } from '@apollo/client';

const allMediagroups: DocumentNode = gql`
  query all_media_groups {
    allMediaGroups {
      edges {
        node {
          id
          name
          description
        }
      }
    }
  }
`;

export default allMediagroups;
